module.exports = __webpack_public_path__ + "static/media/image 58.a537708e.webp";